<app-generic-input [slug]='"year_selector-" + field' [popup]='false' [input]='true' (selected)='data.filters[field] = $event'>
    <app-filters-placeholder-input [placeholder]='data.filters[field] ? data.filters[field] : placeholder' 
                                [active]='!!data.filters[field]'
                                (clear)='data.filters[field] = null'
                                class='placeholder'
                                ></app-filters-placeholder-input>
</app-generic-input>